import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { useAssetDetailsFromSeriesId } from '../../forces/assetDetails/useAssetDetails';
import { getSuperCoverPageLink } from '../../router/router.deepLinks';
import { AssetNotFound } from '../errorPage/AssetNotFound';

import { CoverPageLoader } from './CoverPageLoader';

export const RedirectOldTvSeriesCoverPage: FC<{ seriesId: string }> = ({ seriesId }) => {
  const { data: assetDetails, isLoading } = useAssetDetailsFromSeriesId(seriesId);

  if (isLoading) {
    return <CoverPageLoader />;
  }

  // redirect / upgrade to new super cover page
  const scpLink = assetDetails && getSuperCoverPageLink(assetDetails);
  if (scpLink) {
    return <Navigate to={scpLink + location.search} replace />;
  }

  return <AssetNotFound contextInfo={`unable to redirect to SCP from seriesId=${seriesId}`} />;
};
